import { defineStore } from "pinia"
import { DateTime } from "luxon"
import { useListOccupationalHealthRecords } from "@/modules/occupational-health/composables/occupational-health-record"
import { useCompanyStore, type CompanyContextToken } from "@/store/company-store"

export interface OccupationalHealthState {
  newOhrCount: number
}

export const useOccupationalHealthStore = defineStore("occupationalHealthStore", {
  persist: { storage: sessionStorage },
  state: (): OccupationalHealthState => {
    return {
      newOhrCount: 0
    }
  },

  actions: {
    async getNewOhrCount(contextToken?: CompanyContextToken) {
      const companyStore = useCompanyStore()
      const token = contextToken ?? companyStore.getCompanyContextToken()
      if (!token || !companyStore.isCompanyContextCurrent(token)) return

      const { count, listOhrs } = useListOccupationalHealthRecords()

      const date = DateTime.now().minus({ days: 7 }).toISODate()

      await listOhrs({ completedOnDateGte: date })
      if (!companyStore.isCompanyContextCurrent(token)) return
      this.newOhrCount = count.value ?? 0
    },

    clearOhrCount() {
      this.newOhrCount = 0
    }
  }
})
